module.exports = __webpack_public_path__ + "static/media/rcsBlackImage-removebg-preview.e3f0ffae.png";